import { Link } from 'react-router-dom';
import { usePreferences } from '@/store/preferences';

/** Global footer: exposes the legal links on every app screen. */
const AppFooter = () => {
  const { language } = usePreferences();
  const privacy = language === 'fr' ? 'Politique de confidentialité' : 'Privacy Policy';
  const del = language === 'fr' ? 'Supprimer mon compte' : 'Delete Account';
  const linkClass =
    'text-xs font-medium text-muted-foreground transition-colors hover:text-foreground';

  return (
    <footer className="flex items-center justify-center gap-4 border-t border-border px-4 py-4 text-center">
      <Link to="/privacy" className={linkClass}>
        {privacy}
      </Link>
      <span className="text-xs text-muted-foreground/40">·</span>
      <Link to="/delete-account" className={linkClass}>
        {del}
      </Link>
    </footer>
  );
};

export default AppFooter;
